export default __webpack_public_path__ + "static/retirement-planning-2-ebc2aa1e864271182a06c915451fd3b6.png";